import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EffyButtonComponent, EffyButtonSize, EffyButtonStyle } from '@effy-tech/angular-common/button';
import { TitleComponent } from '../../title/title.component';
import { YoutubeWrapperComponent } from '../../youtube-wrapper/youtube-wrapper.component';
import { ISubBlockVideos } from './videos';

@Component({
  selector: 'nscf-videos',
  templateUrl: 'videos.component.html',
  styleUrls: ['videos.component.scss'],
  imports: [TitleComponent, NgClass, EffyButtonComponent, YoutubeWrapperComponent],
  host: {
    ngSkipHydration: 'true',
    class: 'block container text-video',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideosComponent {
  readonly element = input.required<ISubBlockVideos>();

  protected readonly buttonSize = EffyButtonSize;
  protected readonly buttonStyle = EffyButtonStyle;
}
